module.exports = __webpack_public_path__ + "static/paperGeometric-94265e336f6dc7cd96cd7bd532fb201c.svg";